export default "__VITE_ASSET__DAmXQkhA__"